function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import * as COLORS from '../../theme/colors';
import { size8 } from '../../theme/scale';
const Wrapper = styled.td`
  ${({
  $color
}) => $color && `color: ${COLORS[$color]};`}
  ${({
  $textAlign
}) => $textAlign && `text-align: ${$textAlign};`}
  ${({
  $width
}) => $width && `width: ${$width};`}
  ${({
  visuallyHidden
}) => visuallyHidden && `
    text-align: center;
  `}
  display: table-cell;
  vertical-align: inherit;
`;
const Dot = styled.div`
  width: ${size8};
  height: ${size8};
  background: ${COLORS.blue300};
  border-radius: 100%;
  display: inline-block;
`;
const Text = styled.span`
  ${({
  visuallyHidden
}) => visuallyHidden && `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  `}
`;
export const TableCell = ({
  children,
  as = 'td',
  color = 'gray800',
  width,
  textAlign = 'left',
  visuallyHidden = false,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $color: color,
    $width: width,
    $textAlign: textAlign,
    visuallyHidden,
    as
  }, props), children === 'unread' && /*#__PURE__*/React.createElement(Dot, {
    "aria-hidden": true,
    "data-testid": "readDot"
  }), /*#__PURE__*/React.createElement(Text, {
    visuallyHidden
  }, children));
};
export default TableCell;
//# sourceMappingURL=index.js.map